// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GBupi","text":"styles_text__qKTAn","icon":"styles_icon__ymGDF"};